/* ============================================================
   NOVAA GEAR — delivery-estimate enhancer (cart drawer)
   Computes the "Est delivery" range in TRUE business days
   (skips Sat/Sun) and rewrites [data-novaa-eta]. The Liquid
   in snippets/novaa-cart-drawer.liquid renders a calendar-day
   fallback so no-JS still shows a sensible range.

   Basis (Novaa shipping policy — do not shorten):
     dispatch Sydney 3PL 3–5 business days
     + interstate transit 7–10 business days
     => window = today +10 to +15 BUSINESS days.
   Always a range, never a single promised date.

   The drawer's inner HTML is morphed by Horizon on every cart
   change, so a MutationObserver re-applies after each render.
   ============================================================ */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Public AU holidays are NOT excluded by default — acceptable for an
  // estimate range. Add 'YYYY-MM-DD' strings here to skip them too.
  var HOLIDAYS = [];

  function isSkipped(d) {
    var wd = d.getDay();
    if (wd === 0 || wd === 6) return true;
    var iso =
      d.getFullYear() +
      '-' +
      String(d.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(d.getDate()).padStart(2, '0');
    return HOLIDAYS.indexOf(iso) !== -1;
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!isSkipped(d)) added++;
    }
    return d;
  }

  function fmt(d) {
    return d.getDate() + ' ' + MONTHS[d.getMonth()];
  }

  function renderEta(el) {
    var min = parseInt(el.getAttribute('data-eta-min'), 10);
    var max = parseInt(el.getAttribute('data-eta-max'), 10);
    if (isNaN(min)) min = 10;
    if (isNaN(max)) max = 15;
    var today = new Date();
    var text = fmt(addBusinessDays(today, min)) + ' – ' + fmt(addBusinessDays(today, max));
    // Guard: only write when changed, so our own write doesn't retrigger
    // the MutationObserver in a loop.
    if (el.textContent !== text) el.textContent = text;
  }

  function renderAll(root) {
    var els = (root || document).querySelectorAll('[data-novaa-eta]');
    for (var i = 0; i < els.length; i++) renderEta(els[i]);
  }

  function init() {
    renderAll();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () {
      renderAll();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
